import { render, staticRenderFns } from "./MailSidebar.vue?vue&type=template&id=c6fab728&scoped=true"
import script from "./MailSidebar.vue?vue&type=script&lang=js"
export * from "./MailSidebar.vue?vue&type=script&lang=js"
import style0 from "./MailSidebar.vue?vue&type=style&index=0&id=c6fab728&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6fab728",
  null
  
)

export default component.exports